export default __webpack_public_path__ + "static/media/verificationsFull.f5b0c39a.png";